import type { CRMAccount, CRMLead } from '@/types/api';

const APOLLO_APP_BASE_URL = 'https://app.apollo.io';

type ApolloMetadata = {
  apollo?: {
    apollo_account_id?: string | null;
    apollo_contact_id?: string | null;
    last_event?: {
      event_type?: string | null;
      status?: string | null;
      occurred_at?: string | null;
      reason?: string | null;
      note?: string | null;
    } | null;
  } | null;
};

function normalizeApolloId(value?: string | null) {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}

export function getApolloContactIdForLead(lead: CRMLead) {
  return normalizeApolloId((lead.extra_metadata as ApolloMetadata | undefined)?.apollo?.apollo_contact_id);
}

export function getApolloAccountIdForLead(lead: CRMLead) {
  return normalizeApolloId((lead.extra_metadata as ApolloMetadata | undefined)?.apollo?.apollo_account_id);
}

export function getApolloLastEventForLead(lead: CRMLead) {
  return ((lead.extra_metadata as ApolloMetadata | undefined)?.apollo?.last_event ?? null);
}

export function getApolloContactUrl(contactId?: string | null) {
  const normalized = normalizeApolloId(contactId);
  return normalized ? `${APOLLO_APP_BASE_URL}/#/contacts/${normalized}` : null;
}

export function getApolloAccountUrl(accountId?: string | null) {
  const normalized = normalizeApolloId(accountId);
  return normalized ? `${APOLLO_APP_BASE_URL}/#/accounts/${normalized}` : null;
}

export function getApolloSequenceUrl(sequenceId?: string | null) {
  const normalized = normalizeApolloId(sequenceId);
  return normalized ? `${APOLLO_APP_BASE_URL}/#/emailer_campaigns/${normalized}` : null;
}

export function getApolloLeadUrls(lead: CRMLead) {
  const contactId = getApolloContactIdForLead(lead);
  const accountId = getApolloAccountIdForLead(lead);
  return {
    contactId,
    accountId,
    contactUrl: getApolloContactUrl(contactId),
    accountUrl: getApolloAccountUrl(accountId),
    sequenceUrl: getApolloSequenceUrl(lead.apollo_sequence_id),
  };
}

export function getApolloAccountUrls(account: CRMAccount) {
  return {
    accountUrl: getApolloAccountUrl(account.apollo_account_id),
  };
}
